/* global trackPageview */

const $ = jQuery;
const ACTIVE_CLASS = 'ptfeature__link--active';

export default class MobilePriceTable {
    constructor() {
        let that = this;
        $(window).on('hashchange', () => {
            that._checkActiveStateByUrl();
        });

        $('a[data-pricetable]').on('click', (e) => {
            e.preventDefault();
            if ($(e.currentTarget).hasClass(ACTIVE_CLASS)) {
                return false;
            }
            let targetId = $(e.currentTarget).data('pricetable');
            let href = $(e.currentTarget).attr('href');
            this._changePriceTable(targetId);
            history.pushState(
                {
                    urlPath: href
                },
                '',
                href
            );
        });

        $('a[data-pricetablecolumn]').on('click', (e) => {
            e.preventDefault();
            const HIDE_CLASS = 'table__hideonmobile';
            if ($(e.currentTarget).hasClass(ACTIVE_CLASS)) {
                return false;
            }
            let targetId = $(e.currentTarget).data('pricetablecolumn');
            let tableId = targetId.substr(0, targetId.lastIndexOf('-'));
            $('#' + tableId).find('.table__data').find('.table__product').addClass(HIDE_CLASS);
            $('#' + targetId).removeClass(HIDE_CLASS);
            $('a[data-pricetablecolumn]').removeClass(ACTIVE_CLASS);
            $('a[data-pricetablecolumn="' + targetId + '"]').addClass(ACTIVE_CLASS);
        });


        $('#pricetable__awesomplete .mobile__select').on('change', (e) => {
            let targetId = $(e.currentTarget).attr('value');
            this._changePriceTable(targetId);
        });

        this._checkActiveStateByUrl();
    }

    _checkActiveStateByUrl() {
        if ($('.block--pricetable').length < 1) {
            return;
        }
        let hash = window.location.hash;
        let listItem = $('#pricetable__awesomplete .mobile__list').find('li[data-value="pricetable-' + hash.replace('#', '') + '"]');
        let text = '';
        if (listItem.length > 0) {
            text = listItem.text();
        } else {
            text = $('#pricetable__awesomplete .mobile__list').find('li').first().text();
        }

        $('#pricetable__awesomplete .form-field__label > span').html(text);
        let targetId;
        if (hash.length > 0 && $('a[href*="' + hash + '"][data-pricetable]').length > 0) {
            targetId = $('a[href*="' + hash + '"]').data('pricetable');
        } else {
            // no hash is set, take the first link
            targetId = $('.product__nav .ptfeature__list > .ptfeature__item').first().find('a').data('pricetable');
        }
        this._changePriceTable(targetId);
    }

    _changePriceTable(targetId) {
        let pagename = location.pathname;
        pagename += (location.pathname.substr(-1) === '/') ?  '' : '/';
        pagename += targetId.replace('pricetable-', '');
        pagename += '/';
        pagename += location.search;
        // trackPageview(pagename);
        const TABLE_CLASS = 'pricetables__wrapper';
        const HIDE_CLASS = 'pricetables__wrapper--hide';
        $('.' + TABLE_CLASS).addClass(HIDE_CLASS);
        $('#' + targetId).removeClass(HIDE_CLASS);
        $('a[data-pricetable]').removeClass(ACTIVE_CLASS);
        $('a[data-pricetable="' + targetId + '"]').addClass(ACTIVE_CLASS);
        $('#' + targetId).find('.ptfeature__link').first().trigger('click');
        // $('html, body').scrollTop(0);
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/MobilePriceTable.js